import useReducer from '@store/useReducer'

import * as IncidentStore from '@store/incident/incident'
import * as EDLStore from '@store/edl/edl'
import * as ControleStore from '@store/controle/controle'

const useDrafts = () => {
  const incidentDrafts = useReducer(IncidentStore.store, (s) => s.forms)
  const edlDrafts = useReducer(EDLStore.store, (s) => s.forms)
  const controleDrafts = useReducer(ControleStore.store, (s) => s.forms)

  const draftsCount = incidentDrafts.length + edlDrafts.length + controleDrafts.length

  return [draftsCount] as const
}

export default useDrafts
